const audioContext = new (window.AudioContext || window.webkitAudioContext)({});

export default audioContext;

export function resume() {
	if (audioContext.state !== "running") {
		return audioContext.resume();
	}
}
